import React, { memo } from 'react';
export var RecommendedCheckMark = /*#__PURE__*/memo(function (_ref) {
  var _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? 'checkmark' : _ref$alt,
      _ref$bgFill = _ref.bgFill,
      bgFill = _ref$bgFill === void 0 ? '#FFA06A' : _ref$bgFill,
      _ref$checkFill = _ref.checkFill,
      checkFill = _ref$checkFill === void 0 ? '#FFFFFF' : _ref$checkFill,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '30px' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '30px' : _ref$width;
  return /*#__PURE__*/React.createElement("svg", {
    alt: alt,
    height: height,
    width: width,
    viewBox: "0 0 30 30",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.582.448l1.454.945c.581.363 1.162.509 1.816.436l1.09-.073c1.163-.145 2.18.437 2.69 1.454l.799 1.526c.29.582.727 1.018 1.38 1.308l.946.436c1.09.436 1.744 1.454 1.671 2.617l-.145 1.744c0 .654.145 1.235.581 1.817l.581.8c.727.944.727 2.18.073 3.124l-.872 1.454c-.436.581-.581 1.162-.436 1.816l.073 1.09c.145 1.163-.436 2.18-1.454 2.69l-1.526.799c-.654.29-1.017.727-1.308 1.38l-.436.946c-.436 1.09-1.454 1.744-2.69 1.671l-1.67-.145c-.655 0-1.236.145-1.817.581l-.8.581c-.945.727-2.18.727-3.198.073l-1.38-.872c-.582-.436-1.163-.581-1.817-.436l-1.09.073c-1.163.145-2.18-.436-2.762-1.454l-.727-1.526c-.29-.654-.726-1.017-1.38-1.308l-.945-.436c-1.09-.436-1.745-1.454-1.672-2.69l.145-1.67c0-.655-.145-1.236-.58-1.817l-.582-.8c-.727-.945-.8-2.18-.146-3.198l.945-1.38c.363-.582.509-1.163.436-1.817l-.073-1.09c-.145-1.163.437-2.18 1.454-2.762l1.526-.727a2.701 2.701 0 001.308-1.38l.436-.945c.436-1.09 1.454-1.745 2.617-1.672l1.744.145c.654 0 1.235-.145 1.817-.58l.8-.582c.944-.727 2.18-.8 3.124-.146zM9.334 15.41c-.445-.436-.445-1.164 0-1.673.518-.436 1.26-.436 1.705 0l2.446 2.4 5.485-5.745a1.117 1.117 0 011.631-.072c.519.436.519 1.163.074 1.6l-6.3 6.69c-.445.509-1.26.509-1.706.072L9.334 15.41z",
    fill: bgFill
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.334 15.409c-.445-.436-.445-1.164 0-1.673.518-.436 1.26-.436 1.705 0l2.446 2.4 5.485-5.745a1.117 1.117 0 011.631-.072c.519.436.519 1.163.074 1.6l-6.3 6.69c-.445.509-1.26.509-1.706.072L9.334 15.41z",
    fill: checkFill
  })));
});